import reportWebVitals from "./reportWebVitals";
export default reportWebVitals